import { render } from "./ProfileFriendCard.vue?vue&type=template&id=699254de&scoped=true"
import script from "./ProfileFriendCard.vue?vue&type=script&lang=js"
export * from "./ProfileFriendCard.vue?vue&type=script&lang=js"

import "./ProfileFriendCard.vue?vue&type=style&index=0&id=699254de&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699254de"]])

export default __exports__